import { css } from '@emotion/core';
import { theme } from '@weave/theme';

export const checklistFieldStyle = css`
  > label {
    margin-bottom: ${theme.spacing(1)};
  }
`;
